import React, { useEffect, useState } from 'react';
import { Button, Input, Message, Radio } from '@alifd/next';
import { Modal } from 'antd'; // dialog UI
import client from '../../../../lib/feathers';
import styles from './index.module.scss';

const RadioGroup = Radio.Group;

const MachineInspectFrontDeskList = () => {
  const communityDevice = client.service('communityDevice');
  const machineInspectResult = client.service('machineInspectResult');
  const [householdNumber, setHouseholdNumber] = useState('');
  const [communityDeviceDate, setCommunityDeviceDate] = useState([]);
  const [communityDeviceArr, setCommunityDeviceArr] = useState([]);
  const [checkListDialog, setCheckListDialog] = useState(false);
  const [addCheckList, setAddCheckList] = useState({
    deviceId: '',
    summary: '',
    answer: [],
    checkList: [],
    remark: '',
  });

  useEffect(() => {
    client
      .reAuthenticate()
      .then((res) => {
        setHouseholdNumber(res.user.householdNumbers[0]);
      })
      .catch((err) => console.log(err));
    communityDevice
      .find({ query: { checkList: { $ne: null } } })
      .then((result) => {
        setCommunityDeviceDate(result.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [communityDevice]);
  return (
    <>
      <div className={styles.mobilePostal}>
        <div className={styles.mobilePostalBackground} />
        <div className={styles.visitorHeader}>
          {communityDeviceDate.map((item) => (
            <Button
              key={item._id}
              type="primary"
              className={styles.myAppointmentBtn}
              onClick={() => {
                setCheckListDialog(true);
                setCommunityDeviceArr(item);
                const newAddCheckList = { ...addCheckList };
                newAddCheckList.deviceId = item._id;
                newAddCheckList.checkList = item.checkList;
                setAddCheckList(newAddCheckList);
              }}
            >
              {item.deviceName}
            </Button>
          ))}
        </div>
        <Modal
          okText="確定"
          closable={false}
          mask={false}
          className={styles.modal}
          visible={checkListDialog}
          onOk={() => {
            let newAnswer = {};
            addCheckList.checkList.map((item, index) => {
              const newItem = {};
              newItem[item] = addCheckList.answer[index];
              newAnswer = { ...newAnswer, ...newItem };
              return newAnswer;
            });
            const newCheckList = {
              deviceId: addCheckList.deviceId,
              inspectResult: newAnswer,
              summary: addCheckList.summary,
              inspector: householdNumber,
              remark: addCheckList.remark,
            };

            machineInspectResult
              .create(newCheckList)
              .then(() => {
                Message.success('巡邏狀況填寫成功');
                setCheckListDialog(false);
                setAddCheckList({
                  deviceId: '',
                  summary: '',
                  answer: [],
                  checkList: [],
                  remark: '',
                });
              })
              .catch((error) => console.log(error));
          }}
          onCancel={() => {
            setCheckListDialog(false);
          }}
        >
          <div className={styles.previewContainer}>
            <p className={styles.title}>
              {communityDeviceArr.deviceName}巡檢表
            </p>

            <p className={styles.checkList}>設備整體狀況：</p>
            <p>
              <RadioGroup
                value={addCheckList.summary}
                onChange={(value) => {
                  const newAddCheckList = { ...addCheckList };
                  newAddCheckList.summary = value;

                  setAddCheckList(newAddCheckList);
                }}
                aria-labelledby="groupId"
              >
                <Radio id="良" value="良">
                  良好
                </Radio>
                <Radio id="普" value="普">
                  普通
                </Radio>
                <Radio id="劣" value="劣">
                  劣等
                </Radio>
              </RadioGroup>
            </p>
            {communityDeviceArr?.checkList &&
              communityDeviceArr.checkList.map((item, index) => (
                <>
                  <p className={styles.checkList} key={index}>
                    檢核項目{index + 1}：{item}
                  </p>
                  <p>
                    <RadioGroup
                      value={addCheckList.answer[index]}
                      // value={this.state.value}
                      // onChange={this.onChange}
                      onChange={(value) => {
                        const newAddCheckList = { ...addCheckList };
                        newAddCheckList.answer[index] = value;
                        setAddCheckList(newAddCheckList);
                      }}
                      aria-labelledby="groupId"
                    >
                      <Radio id="良" value="良">
                        良好
                      </Radio>
                      <Radio id="普" value="普">
                        普通
                      </Radio>
                      <Radio id="劣" value="劣">
                        劣等
                      </Radio>
                    </RadioGroup>
                  </p>
                </>
              ))}
            <p className={styles.checkList}>備註：</p>
            <p>
              <Input.TextArea
                value={addCheckList.remark}
                style={{ width: 300 }}
                placeholder="TextArea"
                maxLength={100}
                rows={4}
                showlimithint
                aria-label="input max length 100"
                onChange={(value) => {
                  const newAddCheckList = { ...addCheckList };
                  newAddCheckList.remark = value;
                  setAddCheckList(newAddCheckList);
                }}
              />
            </p>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default MachineInspectFrontDeskList;
